import React from 'react';
import { Link } from 'react-router-dom';

interface CTAButtonProps {
  to?: string;
  text: string;
  arrow?: boolean;
  back?: boolean;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

const CTAButton: React.FC<CTAButtonProps> = ({ 
  to, 
  text, 
  arrow = false, 
  back = false,
  className = "", 
  onClick,
  type = 'button',
  disabled = false
}) => {
  const buttonClasses = `
    ${back ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' : 'bg-prussian-blue text-white hover:bg-prussian-blue/90'} 
    transition-all duration-300 ease-in-out
    px-6 py-3 rounded
    font-medium inline-flex items-center justify-center
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-prussian-blue
    ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
    ${className}
  `;

  // If onClick is provided or type is specified, render a button
  if (onClick || !to) {
    return (
      <button type={type} onClick={onClick} disabled={disabled} className={buttonClasses}>
        {back && <span className="mr-2">←</span>}
        {text}
        {arrow && <span className="ml-2">→</span>}
      </button>
    );
  }

  // Otherwise render a Link
  return (
    <Link to={to} className={buttonClasses}>
      {back && <span className="mr-2">←</span>}
      {text}
      {arrow && <span className="ml-2">→</span>}
    </Link>
  );
};

export default CTAButton;
